<template>
	<ProcessCreatePage>
		<Header :title="isNewCase ? $t('new_damage_case_damage_assessor').toString() : $t('generate_form_damage_assessor').toString()">
			<p>
				{{ $t('required_data_red_stars') }}
			</p>
		</Header>

		<div class="main justify-center">
			<BaseSelect
				class="w-1/3"
				ref="BaseSelect"
				:required="!isSkippable"
				:label="$t('damage_assessor_company')"
				@input="prefill($event)"
				:options="damageAssessorCompanyOptions"
				v-model="selectedDamageAssessorCompany"
				:allow-empty="false"
			/>
			<div v-if="evaluateFields">
				<BaseInput
					ref="BaseInput.model.address"
					:required="false"
					class="w-full md:w-1/2 pr-0 md:pr-1"
					:label="$t('company_organisation_assessor_office')"
					v-if="selectedDamageAssessorCompany.id === null"
					v-model="damageAssessor.organisation"
					type="text"
				/>
				<div>
					<PersonNameForm ref="PersonNameForm" v-model="damageAssessor" :disabled="evaluateDisabled" :show-company="false" />

					<AddressInput ref="AddressInput" :disabled="evaluateDisabled" v-model="damageAssessor" />

					<div class="flex flex-wrap">
						<BaseInput
							ref="BaseInput.model.phoneNumber"
							:required="true"
							:disabled="evaluateDisabled"
							class="w-full md:w-1/2 pr-0 md:pr-2"
							:label="$t('phone')"
							v-model="damageAssessor.cellNumber"
							type="tel"
							validationtype="phone"
						/>
						<BaseInput
							:required="true"
							ref="BaseInput.model.email"
							class="w-full md:w-1/2 md:pl-2"
							:label="$t('e_mail')"
							:disabled="evaluateDisabled"
							v-model="damageAssessor.email"
							type="email"
						/>
					</div>
				</div>
			</div>
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick()"
			@skipButtonClick="continueButtonClick(true)"
			:is-back-button="!hideBackBtn"
			:is-skippable="isSkippable"
		/>
	</ProcessCreatePage>
</template>

<script>
import Footer from '@/components/damagecases/Footer';
import Header from '@/components/damagecases/Header';
import RepairShopRepository from '@/api/repositories/RepairShopRepository';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import PersonNameForm from '@/components/forms/PersonNameForm.vue';
import AddressInput from '@/components/forms/AddressInput.vue';
import Validate from '@/mixins/Validate';

export default {
	name: 'DamageAssessor',
	components: { AddressInput, PersonNameForm, BaseInput, ProcessCreatePage, Header, Footer, BaseSelect },
	mixins: [Validate],
	props: {
		startValue: {},
		hideBackBtn: { type: Boolean, default: false },
		isSkippable: { default: true },
		isNewCase: { default: true },
		isExpertiseSelected: { default: false },
	},
	data() {
		return {
			model: {
				city: {
					zipCode: null,
					name: null,
				},
			},
			options: [],
			isNewDamageAssessor: false,
			damageAssessor: { city: {} },
			damageAssessorCompanyOptions: [],
			selectedDamageAssessorCompany: null,
			damageAssessorPersonOptions: [],
			isLoading: true,
		};
	},
	computed: {
		evaluateFields() {
			return this.selectedDamageAssessorCompany === this.damageAssessorCompanyOptions[0] && (this.isNewCase || !this.isExpertiseSelected);
		},
		evaluateDisabled() {
			return this.selectedDamageAssessorCompany !== this.damageAssessorCompanyOptions[0];
		},
	},
	methods: {
		continueButtonClick: function(isSkip) {
			if (isSkip) {
				this.$emit('next', null);
			} else {
				if (this.validate()) {
					if (this.selectedDamageAssessorCompany === null) {
						if (this.isSkippable) {
							this.$swal(this.$t('general.attention').toString(), this.$t('fill_or_skip').toString(), 'warning');
						} else {
							this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
						}
					} else {
						if (this.damageAssessor.id != null) {
							this.damageAssessor.damage_assessor_id = this.damageAssessor?.personableId;
						}
						//also send company data for generating documents
						if (this.selectedDamageAssessorCompany === this.damageAssessorCompanyOptions[0] && (this.isNewCase || !this.isExpertiseSelected)) {
							this.$emit('next', {
								damageAssessor: this.damageAssessor,
								damageAssessorNonSystemPartner: this.selectedDamageAssessorCompany === this.damageAssessorCompanyOptions[0],
							});
						} else {
							this.$emit('next', {
								damageAssessorCompany: this.selectedDamageAssessorCompany,
								damageAssessorNonSystemPartner: false,
							});
						}
					}
				} else {
					this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				}
			}
		},
		prefill($event) {
			this.selectedDamageAssessorCompany = $event;
			if ($event) {
				this.damageAssessor = {
					...this.selectedDamageAssessorCompany,
					name: this.selectedDamageAssessorCompany.name,
					city: {
						name: this.selectedDamageAssessorCompany.name,
						zipCode: this.selectedDamageAssessorCompany.zipCode || '',
					},
				};
			} else {
				this.damageAssessor = {};
			}

			if (this.customSelected) {
				this.validIgnored = [];
			}
		},
	},
	mounted() {
		const repairShopId = this.$store.getters.getUser.person.company.companyable.id;
		RepairShopRepository.damageAssessors(repairShopId).then(response => {
			this.damageAssessorCompanyOptions = response.data.data.map(option => {
				option.value = option.id;
				option.display = option.name;
				return option;
			});
			if (this.isNewCase || !this.isExpertiseSelected) {
				this.damageAssessorCompanyOptions.unshift({
					id: null,
					name: null,
					display: this.$t('foreign_assessor'),
					highlight: true,
					houseNumber: null,
					street: null,
					phoneNumber: null,
					email: null,
					city: {
						zipCode: null,
						name: null,
					},
					isEditable: true,
					highlight_suffix: this.highlight_suffix || null,
				});
			}
		});
	},
};
</script>

<style scoped></style>
